import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const useCylinderTypes = () => {
  const [types, setTypes] = useState([]);
  useEffect(() => { api.get("/cylinder-types").then(({ data }) => setTypes(data.data || [])).catch(() => {}); }, []);
  return types;
};

export const CylinderTypeSelect = ({ types, value, onChange, testId = "cylinder-type-select" }) => (
  <Select value={value || ""} onValueChange={onChange}>
    <SelectTrigger className="rounded-sm mt-1" data-testid={testId}><SelectValue placeholder="Select cylinder type" /></SelectTrigger>
    <SelectContent>
      {types.map((t) => (
        <SelectItem key={t.id} value={t.id} data-testid={`${testId}-option-${t.cylinder_kg}`}>
          {t.name} · UGX {Number(t.cylinder_price).toLocaleString()} per cylinder · {Number(t.price_per_m3).toLocaleString(undefined, { maximumFractionDigits: 2 })}/m³
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
